<template>
  <div class="d-flex align-items-center">
    <div class="lg-hongs-logo">
      <img
        :src="staticImgBaseUrl + '/images/global/loginLogoHK.svg'"
        class="star-img"
        @click="sendToHome()"
      />
    </div>
    <div v-if="headerText" class="bold fs-16 pl25">{{ headerText }}</div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import { staticImgBaseUrl } from "../config/apiEndpoints";
import utility from "../helpers/utility";

export default {
  name: "HongsLogo",
  components: {
    //
  },
  data() {
    return {
      staticImgBaseUrl,
      headerText: "",
    };
  },
  mounted() {
    //
    if (utility.isCurrentlyAtUrl("/menu/")) {
      this.headerText = "Menu";
    } else if (utility.isCurrentlyAtUrl("/cart-unified/")) {
      this.headerText = "Cart";
    } else if (utility.isCurrentlyAtUrl("/my-favourites")) {
      this.headerText = "My Favourites";
    } else if (utility.isCurrentlyAtUrl("/offers")) {
      this.headerText = "Offers for you";
    } else if (utility.isCurrentlyAtUrl("/my-addresses")) {
      this.headerText = "My Addresses";
    } else {
      this.headerText = "";
    }
  },
  methods: {
    //
    sendToHome() {
      utility.redirectToHomeOrRedirectUrl();
    },
  },
};
</script>
